import api from '../api';

const BASE_URL = '/api/v2/auth';

const AuthAPI = {
	index: () => api.get(BASE_URL),
	post: (payload) => api.post(`${BASE_URL}/talk-play`, payload),
};

export default AuthAPI;
